import { render, staticRenderFns } from "./RolesUpdateModal.vue?vue&type=template&id=eed3a240&"
import script from "./RolesUpdateModal.vue?vue&type=script&lang=js&"
export * from "./RolesUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports